import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  flex: 1;
  padding: 8px;
  box-sizing: border-box;

  border-radius: 8px;
  border: 1px solid var(--Border-Neutral-faded, #dfe2ea);
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8;
`

export const LabelDate = styled.label`
  flex: 1;

  color: var(--Text-Secondary, #4d5874);

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
`

export const MoreIconContainer = styled.div`
  cursor: pointer;

  width: 16px;
  height: 16px;

  display: flex;
  align-items: center;
  justify-content: center;

  overflow: hidden;
`

export const FilePreviewContainer = styled.div`
  height: 200px;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
`

export const FilePreview = styled.img`
  height: 200px;
  width: 100%;
  object-fit: cover;

  border-radius: 6px;
`

export const TrashIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  overflow: hidden;

  svg {
    width: 20px;
    height: 20px;
  }
`

export const Value = styled.div`
  user-select: text;

  color: var(--Text-Secondary, #4d5874);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  overflow-wrap: anywhere;
`
